import { render, staticRenderFns } from "./detailFundingAgency.vue?vue&type=template&id=b8a91c2e&scoped=true"
import script from "./detailFundingAgency.vue?vue&type=script&lang=js"
export * from "./detailFundingAgency.vue?vue&type=script&lang=js"
import style0 from "./detailFundingAgency.vue?vue&type=style&index=0&id=b8a91c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a91c2e",
  null
  
)

export default component.exports